<template>
  <div class="liu pos-manage">
    <camera ref="camera" @getImgInfo="getCameraImgInfo" />
    <mt-header fixed title="上传承诺函" class="title1"></mt-header>
    <div class="scroll-container">
      <div>
        <div class="mt-15 bg-text">
          <p class="title-text">承诺函</p>
          <p class="content-text text-indent">
            我司承诺已全部阅读及充分理解我司与嘉联支付有限公司签署<span class="red">《特约商户受理银行卡协议书》</span>(协议编号：{{
              commitData.authNumber
            }})的各项条款,并愿意遵守该协议的各项规定，我司确认本承诺函的签署自愿、真实、合法、有效不存在任何虚假。
            <br />
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本承诺函扫描件与原件具有同等法律效力。</span>
          </p>
          <p class="content-text text-right">
            法人(签字并加盖公章)<br />日期&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日
          </p>
        </div>
        <div class="mt-15 bg-text fee">
          <span class="fee-left">费率(万分之):{{ commitData.fee }}</span><span class="fee-right">服务费:{{ commitData.serviceFee }}元</span>
        </div>
        <p class="tip">
          请手动抄写或打印以上文字，法人需要盖章，个体工商户需要签字加按手印，完成后点击拍照上传。
        </p>
        <div class="mt-15 bg-text">
          <div class="picture text-center" @click="$refs.camera.imgClick('agreePicture')">
            <img v-if="agreePicture != ''" class="mt-15 agree-picture" :src="agreePicture" alt="" />
            <svg-icon v-else icon-class="camera_comm" class="mt-15"></svg-icon>
          </div>
        </div>
        <div class="btn">
          <mt-button type="primary" size="large" @click="uploadInfo">
            确定
          </mt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import camera from '@/components/camera';
import { commitmentUpLoadImg } from '@/utils/utils';
import { GetCustomerNumber, UploadAuthCommitmentPicUrl } from '@/api/customer';
import { formatMoneyToYuan, formatRateToWan } from '@/utils/format';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast } from '@/utils/CustomToast';
import { Indicator, MessageBox } from 'mint-ui';
export default {
  name: 'H5PosManageCommitment',
  components: { camera },
  data() {
    return {
      commitData: {
        serviceFee: '',
        fee: '',
        authNumber: '',
        imageUploadUrl: '',
      },
      userId: '',
      agreePicture: '', // 协议照片
    };
  },
  mounted() {
    var id = this.$route.query.id;
    // 获取编号和费率
    Indicator.open({
      text: '加载中...',
      spinnerType: 'fading-circle',
    });
    this.userId = id || '';
    this.getQueryString(id);
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 返回的图片信息
    getCameraImgInfo(info) {
      commitmentUpLoadImg(info.blob, info.base64, info.type, this.commitData.imageUploadUrl, res => {
        switch (info.type) {
          case 'agreePicture':
            this.agreePicture = res.data;
            break;
        }
      });
    },
    //
    getQueryString(id) {
      GetCustomerNumber({
        id: id,
      })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              Indicator.close();
              this.commitData.serviceFee = formatMoneyToYuan(res.data.serviceFee);
              this.commitData.fee = formatRateToWan(res.data.fee);
              this.commitData.authNumber = res.data.authNumber;
              this.commitData.imageUploadUrl = res.data.imageUploadUrl;
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 上传图片信息地址
    uploadInfo() {
      if (this.agreePicture === '') {
        CusToast('图片不能为空');
        return;
      }
      MessageBox.confirm('', {
        title: '提示',
        message: '确定提交授权书吗',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      })
        .then(action => {
          if (action === 'confirm') {
            Indicator.open({
              text: '加载中...',
              spinnerType: 'fading-circle',
            });
            UploadAuthCommitmentPicUrl({
              authImgUrl: this.agreePicture,
              authNumber: this.commitData.authNumber,
              id: this.userId,
            })
              .then(res => {
                SucceedHandle2(
                  res.code,
                  res.msg,
                  () => {
                    res.msg && CusToast(res.msg);
                    Indicator.close();
                  },
                  (code, msg) => {
                    Indicator.close();
                    msg && CusToast(msg);
                  }
                );
              })
              .catch(err => {
                Indicator.close();
                const msg = NotSucceedHandle(err.message);
                msg && CusToast(msg);
              });
          }
        })
        .catch(error => {
          if (error === 'cancel') {
            console.log('点击取消');
          }
        });
    },
  },
};
</script>
